export const polishMask = '+48 999 999 999';
export const polishPrefix = '+48 ';
